(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["berrys-luxury-footer"]) return;
  try {
    
if (!customElements.get('berrys-luxury-footer')) {
  customElements.define('berrys-luxury-footer', class extends HTMLElement {
    connectedCallback() {
      if (this.footerController) return;
      this.footerController = new AbortController();
      const signal = this.footerController.signal;
      if (this.dataset.newsletterAfterShowrooms === 'true') {
        this.homeNewsletter = this.querySelector('.bf-newsletter');
        if (this.homeNewsletter) {
          this.newsletterAnchor = document.createComment('');
          this.homeNewsletter.before(this.newsletterAnchor);
          const positionNewsletter = () => {
            const banner = document.querySelector('main [id^="BerrysFiveCities-"]');
            const target = banner && banner.closest('.shopify-section');
            if (!target) {
              this.newsletterAnchor.after(this.homeNewsletter);
              if (this.newsletterWrapper) this.newsletterWrapper.remove();
              return;
            }
            if (!this.newsletterWrapper) {
              this.newsletterWrapper = document.createElement('div');
              this.newsletterWrapper.className = 'berrys-luxury-footer';
              this.newsletterWrapper.setAttribute('data-home-newsletter', '');
            }
            this.newsletterWrapper.style.cssText = this.style.cssText;
            this.newsletterWrapper.append(this.homeNewsletter);
            target.after(this.newsletterWrapper);
          };
          positionNewsletter();
          document.addEventListener('DOMContentLoaded', positionNewsletter, {once: true, signal});
          document.addEventListener('shopify:section:load', positionNewsletter, {signal});
          document.addEventListener('shopify:section:reorder', positionNewsletter, {signal});
        }
      }

      const groups = Array.from(this.querySelectorAll('.bf-group'));
      const mobile = window.matchMedia('(max-width: 900px)');
      const sync = () => groups.forEach(group => { group.open = !mobile.matches; });
      sync();
      mobile.addEventListener('change', sync, {signal});
      groups.forEach(group => group.querySelector('.bf-group-title').addEventListener('click', event => {
        if (!mobile.matches) event.preventDefault();
      }, {signal}));
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        let current = event.target;
        while (current && current !== this) {
          if (current.tagName === 'DETAILS') current.open = true;
          current = current.parentElement;
        }
      }, {signal});
    }
    disconnectedCallback() {
      if (this.newsletterAnchor && this.homeNewsletter) {
        this.newsletterAnchor.after(this.homeNewsletter);
        this.newsletterAnchor.remove();
      }
      if (this.newsletterWrapper) this.newsletterWrapper.remove();
      this.newsletterWrapper = null;
      if (this.footerController) this.footerController.abort();
      this.footerController = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["berrys-patek-product"]) return;
  try {
    

if (!customElements.get('berrys-patek-product')) {
  customElements.define('berrys-patek-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      if (!dialog) return;
      this.querySelectorAll('[data-patek-enquiry]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !dialog.showModal) return;
          event.preventDefault();
          this.opener = link;
          const frame = dialog.querySelector('[data-patek-form]');
          if (!frame.hasAttribute('src')) frame.src = frame.dataset.src;
          dialog.showModal();
          dialog.scrollTop = 0;
        }, options);
      });
      dialog.querySelector('[data-patek-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); }, options);
      dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
      window.addEventListener('message', event => {
        const frame = dialog.querySelector('[data-patek-form]');
        if (event.source !== frame.contentWindow || event.origin !== 'https://form.jotform.com') return;
        if (typeof event.data !== 'string') return;
        const parts = event.data.split(':');
        if (parts[0] !== 'setHeight') return;
        const height = Number(parts[1]);
        if (Number.isFinite(height) && height >= 300 && height <= 12000) frame.style.height = `${height}px`;
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-colour-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const linkSelector = 'a[data-bj-colour-shop]';
  const collectionSelector = '.shopify-section--main-collection';

  function collectionTarget() {
    return document.querySelector(collectionSelector);
  }

  function setCollectionLinks() {
    const target = collectionTarget();
    if (!target || !target.id) return;
    document.querySelectorAll(linkSelector).forEach((link) => {
      link.setAttribute('href', '#' + target.id);
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest(linkSelector);
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = collectionTarget();
    if (!target || !target.id) return;

    event.preventDefault();
    link.setAttribute('href', '#' + target.id);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setCollectionLinks, { once: true });
  } else {
    setCollectionLinks();
  }
  document.addEventListener('shopify:section:load', setCollectionLinks);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-engagement-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bj-one-carat')) {
  customElements.define('bj-one-carat', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.bj-one-carat__slide')];
      if (this.slides.length < 2 || this.ready) return;
      this.ready = true;
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = Math.max(3000, Math.min(12000, Number(this.dataset.interval) || 5000));
      this.button = this.querySelector('[data-pause]');
      this.updatePause();
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1));
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.explicitPlay = !this.paused; this.updatePause(); });
      this.addEventListener('mouseenter', () => this.hovered = true);
      this.addEventListener('mouseleave', () => this.hovered = false);
      this.observer = new IntersectionObserver(entries => this.visible = entries[0].isIntersecting);
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (!this.paused && this.visible && !document.hidden && (this.explicitPlay || (!this.hovered && !this.contains(document.activeElement)))) this.show(this.index + 1);
      }, this.interval);
    }
    disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); this.ready = false; }
    updatePause() {
      this.button.setAttribute('aria-pressed', String(this.paused));
      this.button.setAttribute('aria-label', this.paused ? 'Start ring rotation' : 'Pause ring rotation');
      this.button.textContent = this.paused ? '▶' : 'Ⅱ';
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
        slide.tabIndex = i === this.index ? 0 : -1;
      });
      this.querySelector('[data-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["br26-sale-selection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialiseSaleSelection(root) {
      if (root.dataset.enhanced) return;
      const tablist = root.querySelector('[data-brsale-tabs]');
      const tabs = Array.from(root.querySelectorAll('[data-brsale-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-brsale-panel]'));
      if (!tablist || !tabs.length || tabs.length !== panels.length) return;
      function selectTab(index, focus) {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        if (focus) tabs[index].focus();
      }
      tablist.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        const panel = panels[index];
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => selectTab(index, false));
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); selectTab(next, true);
        });
      });
      root.dataset.enhanced = 'true'; tablist.hidden = false; selectTab(0, false);
      root.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-brsale-panel]');
        const index = panels.indexOf(panel);
        if (index >= 0) selectTab(index, false);
      });
    }
    function initialiseWithin(scope) {
      if (scope.matches && scope.matches('[data-brsale-selection]')) initialiseSaleSelection(scope);
      scope.querySelectorAll('[data-brsale-selection]').forEach(initialiseSaleSelection);
    }
    initialiseWithin(document);
    document.addEventListener('shopify:section:load', (event) => initialiseWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
document.addEventListener('click', event => {
  const button = event.target.closest('#cart-drawer [data-bdrawer-step]');
  if (!button || button.disabled) return;
  const input = button.closest('.bdrawer-quantity').querySelector('input');
  const next = Number(input.value) + Number(button.dataset.bdrawerStep) * (Number(input.step) || 1);
  const maximum = input.max === '' ? Infinity : Number(input.max);
  if (!Number.isFinite(next) || next < Number(input.min) || next > maximum) return;
  input.value = next;
  input.dispatchEvent(new Event('change', {bubbles:true}));
});
document.addEventListener('change', event => {
  const input = event.target.closest('#cart-drawer input[data-bdrawer-quantity]');
  if (!input || input.checkValidity()) return;
  event.stopImmediatePropagation();
  input.reportValidity();
  input.value = input.dataset.bdrawerQuantity;
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watches-brand-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('watches-brand-directory')) { customElements.define('watches-brand-directory', class extends HTMLElement { connectedCallback() { const field = this.querySelector('input'); if (!field || this.bound) return; this.bound = true; field.addEventListener('input', () => { let count = 0; this.querySelectorAll('.brand-name').forEach(a => { a.hidden = !a.textContent.toLocaleLowerCase().includes(field.value.trim().toLocaleLowerCase()); if (!a.hidden) count++; }); this.querySelector('.no-brands').hidden = count > 0; const status = this.querySelector('.brand-status'); status.textContent = count + ' ' + status.dataset.suffix; }); } }); }

  } catch(e) { console.error(e); }
})();
})();
